// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import Moment from 'moment';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { Spinner } from 'component-library';
import { getGamelogs } from '../../../../redux/actions/gamelogs';
import './../PlayerCard.css';
import './Gamelogs.css';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

// header

type Props = {
    cookies: { [key: string]: any },
    player: { [key: string]: any },
    gamelogs: { [key: string]: any },
    playerDetails: { [key: string]: any },
    sport: string,
    getGamelogs: Function
};

type State = {
    loginCookie: string
};

class Gamelogs extends Component<Props, State> {
    constructor(props) {
        super(props);
        const { cookies } = this.props;
        this.state = {
            loginCookie: cookies.get('flid') || '0'
        };
    }
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    componentDidMount() {
        if (this.props.player !== null) {
            this.props.getGamelogs(
                this.props.player.player_id,
                this.props.sport,
                Moment(this.props.player.event_date_time)
                    .add(1, 'days')
                    .format('YYYY-MM-DD'),
                this.state.loginCookie
            );
        }
    }

    render() {
        const gamelogsHeader = <div className={'modal-subheader'}>Recent Games</div>;
        let gamelogsDisplay = <Spinner />;

        if (this.props.gamelogs.results['0']) {
            const gamelogsArray = this.props.gamelogs.results['0'];
            const gamelogsCount = gamelogsArray.length - 1;
            if (gamelogsCount > 0 && gamelogsArray[gamelogsCount].salary_date === 'Total') {
                gamelogsArray.pop();
            }

            let positionId = 0;
            if (this.props.playerDetails) {
                positionId = this.props.playerDetails.default_position_id;
            }
            let sportColumns = [];
            let gamelogColumns = [];
            const defaultColumns = [
                {
                    Header: 'Date',
                    accessor: 'salary_date',
                    width: 80,
                    Cell: props => <div className="center">{moment(props.value).format('MM/DD')}</div>
                },
                {
                    Header: 'Opponent',
                    accessor: 'opposing_team',
                    minWidth: 120,
                    Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                },
                {
                    Header: 'DK Salary',
                    accessor: 'salary',
                    width: 80,
                    Cell: props => <div className="center">{props.value !== null ? '$' + props.value : ''}</div>
                },
                {
                    Header: 'DK Actual',
                    accessor: 'actual_points',
                    width: 80,
                    Cell: props => <div className="center">{props.value ? props.value.toFixed(2) : ''}</div>
                }
            ];
            if (this.props.sport === 'nfl') {
                if (positionId === '101') {
                    sportColumns = [
                        {
                            Header: 'Comp',
                            accessor: 'stats.passing_completions',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'Att',
                            accessor: 'stats.passing_attempts',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'PYds',
                            accessor: 'stats.passing_yards',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'PTD',
                            accessor: 'stats.passing_touchdowns',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'Int',
                            accessor: 'stats.passing_interceptions',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'RuYds',
                            accessor: 'stats.rushing_yards',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'RuTD',
                            accessor: 'stats.rushing_touchdowns',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        }
                    ];
                } else if (positionId === '102') {
                    sportColumns = [
                        {
                            Header: 'Att',
                            accessor: 'stats.rushing_attempts',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'RuYds',
                            accessor: 'stats.rushing_yards',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'RuTD',
                            accessor: 'stats.rushing_touchdowns',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'Tgts',
                            accessor: 'stats.receiving_targets',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'Rec',
                            accessor: 'stats.receptions',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'ReYds',
                            accessor: 'stats.receiving_yards',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'ReTD',
                            accessor: 'stats.receiving_touchdowns',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        }
                    ];
                } else if (positionId === '103' || positionId === '104') {
                    sportColumns = [
                        {
                            Header: 'Tgts',
                            accessor: 'stats.receiving_targets',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'Rec',
                            accessor: 'stats.receptions',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'ReYds',
                            accessor: 'stats.receiving_yards',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'ReTD',
                            accessor: 'stats.receiving_touchdowns',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        }
                    ];
                } else if (positionId === '105') {
                    sportColumns = [
                        {
                            Header: 'Opp Pts',
                            accessor: 'stats.points_allowed',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'Sacks',
                            accessor: 'stats.sacks',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'FR',
                            accessor: 'stats.fumbles_recovered',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'Int',
                            accessor: 'stats.interceptions',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'Sfty',
                            accessor: 'stats.safeties',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'TD',
                            accessor: 'stats.touchdowns_scored',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        }
                    ];
                } else if (positionId === '106') {
                    sportColumns = [
                        {
                            Header: 'FGA',
                            accessor: 'stats.field_goals_attempted',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'FGM',
                            accessor: 'stats.field_goals_made',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'Long',
                            accessor: 'stats.field_goals_long',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'XPM',
                            accessor: 'stats.extra_points_made',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        }
                    ];
                }
                gamelogColumns = [...defaultColumns, ...sportColumns];
            } else if (this.props.sport === 'nba') {
                sportColumns = [
                    {
                        Header: 'Min',
                        accessor: 'stats.minutes',
                        width: 80,
                        Cell: props => <div className="center">{props.value ? props.value.toFixed(1) : ''}</div>
                    },
                    {
                        Header: 'Pts',
                        accessor: 'stats.points_scored',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                    },
                    {
                        Header: 'Reb',
                        accessor: 'stats.rebounds',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                    },
                    {
                        Header: 'Ast',
                        accessor: 'stats.assists',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                    },
                    {
                        Header: 'Blk',
                        accessor: 'stats.blocks',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                    },
                    {
                        Header: 'Stl',
                        accessor: 'stats.steals',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                    }
                ];
                gamelogColumns = [...defaultColumns, ...sportColumns];
            } else if (this.props.sport === 'mlb') {
                if (positionId === '301') {
                    sportColumns = [
                        {
                            Header: 'AB',
                            accessor: 'stats.ab',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'H',
                            accessor: 'stats.h',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: '2B',
                            accessor: 'stats.doubles',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: '3B',
                            accessor: 'stats.triples',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'HR',
                            accessor: 'stats.hr',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'RBI',
                            accessor: 'stats.rbi',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'BB',
                            accessor: 'stats.bb',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'K',
                            accessor: 'stats.so',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'SB',
                            accessor: 'stats.sb',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        }
                    ];
                } else if (positionId === '302') {
                    sportColumns = [
                        {
                            Header: 'IP',
                            accessor: 'stats.pitch_ip',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'W',
                            accessor: 'stats.pitch_w',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'L',
                            accessor: 'stats.pitch_l',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'Sv',
                            accessor: 'stats.pitch_sv',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'ER',
                            accessor: 'stats.pitch_er',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'BB',
                            accessor: 'stats.pitch_bb',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'K',
                            accessor: 'stats.pitch_so',
                            width: 60,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'ERA',
                            accessor: 'stats.pitch_era',
                            width: 60,
                            Cell: props => (
                                <div className="center">
                                    {props.value !== null && props.value !== undefined ? props.value.toFixed(2) : ''}
                                </div>
                            )
                        }
                    ];
                }
                gamelogColumns = [...defaultColumns, ...sportColumns];
            } else if (this.props.sport === 'nhl') {
                if (positionId === '401' || positionId === '403' || positionId === '404' || positionId === '405') {
                    sportColumns = [
                        {
                            Header: 'TOI',
                            accessor: 'stats.minutes',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'G',
                            accessor: 'stats.goals',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'A',
                            accessor: 'stats.assists',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'PPG',
                            accessor: 'stats.power_play_goals',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'PPA',
                            accessor: 'stats.power_play_assists',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'SOG',
                            accessor: 'stats.shots_on_goal',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'BS',
                            accessor: 'stats.blocks',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        }
                    ];
                } else if (positionId === '402') {
                    sportColumns = [
                        {
                            Header: 'W',
                            accessor: 'stats.goaltending_wins',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'L',
                            accessor: 'stats.goaltending_losses',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'SO',
                            accessor: 'stats.goaltending_shutouts',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'GA',
                            accessor: 'stats.goaltending_goals_against',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        },
                        {
                            Header: 'Sv',
                            accessor: 'stats.goaltending_saves',
                            width: 80,
                            Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                        }
                    ];
                }
                gamelogColumns = [...defaultColumns, ...sportColumns];
            } else if (this.props.sport === 'pga') {
                sportColumns = [
                    {
                        Header: 'Date',
                        accessor: 'salary_date',
                        width: 100,
                        Cell: props => <div className="center">{moment(props.value).format('MM/DD')}</div>
                    },
                    {
                        Header: 'Tour',
                        accessor: 'opposing_team',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                    },
                    {
                        Header: 'Event',
                        accessor: 'home_team',
                        minWidth: 120
                    },
                    {
                        Header: 'Salary',
                        accessor: 'salary',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? '$' + props.value : ''}</div>
                    },
                    {
                        Header: 'Actual',
                        accessor: 'actual_points',
                        width: 80,
                        Cell: props => <div className="center">{props.value ? props.value.toFixed(2) : ''}</div>
                    },
                    {
                        Header: 'Posn',
                        accessor: 'stats.posn',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                    },
                    {
                        Header: 'R1',
                        accessor: 'stats.rd1',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                    },
                    {
                        Header: 'R2',
                        accessor: 'stats.rd2',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                    },
                    {
                        Header: 'R3',
                        accessor: 'stats.rd3',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                    },
                    {
                        Header: 'R4',
                        accessor: 'stats.rd4',
                        width: 80,
                        Cell: props => <div className="center">{props.value !== null ? props.value : ''}</div>
                    }
                ];
                gamelogColumns = [...sportColumns];
            }
            if (this.props.gamelogs.isLoading === false) {
                gamelogsDisplay = (
                    <div className={'gamelogs-container styled-scrollbar'}>
                        <ReactTable
                            data={this.props.gamelogs.results['0']}
                            columns={gamelogColumns}
                            sortable={false}
                            multiSort={false}
                            resizable={false}
                            showPagination={false}
                            defaultPageSize={this.props.gamelogs.results['0'].length}
                            className="-striped -highlight"
                        />
                    </div>
                );
            }
        } else {
            if (this.props.gamelogs.isLoading === false) {
                gamelogsDisplay = <div>No events found.</div>;
            }
        }

        return (
            <React.Fragment>
                {gamelogsHeader}
                {gamelogsDisplay}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        gamelogs: state.gamelogs,
        playerDetails: state.playerDetails.results[0]
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getGamelogs: (playerId, sport, propsDate, sessionId) =>
            dispatch(getGamelogs(playerId, sport, propsDate, sessionId))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withCookies(Gamelogs));



// WEBPACK FOOTER //
// ./src/components/Main/PlayerCard/Gamelogs/Gamelogs.js